export const GATES = {
  ADVANCED_SEARCH: 'SupportSpace:AdvancedSearch:FE'
};